import { Paywall } from '/src/components/Paywall';

import { useFeatureMetric, useAuthContext } from '/src/hooks';

import UfoPNG from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.png';
import UfoWebP from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.webp';

export function AskOwnerWall({ mini }) {
  const { currentAccount } = useAuthContext();

  useFeatureMetric('web_analytics_needs_enabled');

  return (
    <Paywall>
      <Paywall.Image
        webp={UfoWebP}
        fallback={UfoPNG}
        width={mini ? '80px' : '185px'}
        className={mini ? '!mb-3 !mt-2' : '!mt-0 !mb-[25px]'}
        alt="UFO"
      />
      <Paywall.Title mini={mini}>Enable traffic reporting</Paywall.Title>
      <Paywall.Body>
        Want to see traffic and visitor insights?
        <br />
        Ask the account owner to enable web analytics.
      </Paywall.Body>
      <Paywall.Button
        onClick={() => window.open(`mailto:${currentAccount.ownerEmail}`, '_blank')}
        className={mini ? '!mb-0' : ''}
      >
        Contact Account Owner
      </Paywall.Button>
    </Paywall>
  );
}

AskOwnerWall.displayName = 'AskOwnerWall';
